<template lang="pug">
  transition(
    name="modal"
  )
    .modal-mask(
      @click="onClickMask($event)"
    )
      .modal-wrapper
        .modal.modal_error(
          @click="onClickWrapper($event)"
        )
          .modal__close
            //- button.modal-button-close(
            //-   @click="onCloseModal()"
            //- )
            //-   img(src="@/assets/images/icons/modal-button-close.svg")
          .modal__body
            .error
              .error__title
              .error__title--text(
                v-html="text.length > 0 ? text : 'Ошибка!'"
              )
              .error__form.error__form_entry
                form(
                  @submit.prevent="onSubmitMethod"
                )
                  .error-form__elem.error-form__elem_button
                    .form-elem
                      .form-elem__body
                        button.button.button_paint-main.button_paint-secondary(
                          @click="$emit('close')"
                        ) Ок
</template>

<script>
export default {
  name: "ErrorModal",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    onClickMask() {
      this.onCloseModal();
    },
    onClickWrapper(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onCloseModal() {
      this.$emit("close");
    },
    onSubmitMethod(e) {
      e.preventDefault();
    }
  },
  mounted() {}
};
</script>
